import {Trans} from 'react-i18next';
import {OFFER_CATEGORIES, valueof} from '@chekin/core';

type Props = {
  category: valueof<OFFER_CATEGORIES>;
};
export const CategoryTranslation = ({category}: Props) => {
  const key = `offer_categories.${category.toString().toLocaleLowerCase()}`;

  return <Trans i18nKey={key} />;
};
